const editResolver = {
  defaults: {
    app: {
      __typename: "AppSetting",
      drawerOpen: false,
      currentEditProductId: 0,
      currentSno: 0
    }
  },

  resolvers: {
    Mutation: {
      applyChange: (_, { itemId, sno, contents }, { cache, getCacheKey }) => {
        // const fragment = gql`
        //   fragment changeContents on ProductItem {
        //     contents
        //   }
        // `;

        // const itemData = cache.readFragment({ fragment, id: itemId });
        cache.writeData({
          id: getCacheKey({ __typename: "ProductItem", id: itemId, sno }),
          data: { contents }
        });

        // // 변경내용 저장
        // cache.writeFragment({
        //   fragment,
        //   id: itemId,
        //   data: { contents }
        // });
      },

      drawerClose: (_, __, { cache }) => {
        cache.writeData({
          data: {
            app: {
              __typename: "AppSetting",
              drawerOpen: false
            }
          }
        });

        return null;
      }
    }
  }
};

export default editResolver;



// WEBPACK FOOTER //
// ./src/resolvers/editor.resolver.ts